// extracted by mini-css-extract-plugin
export default {"remark":"change-list_remark__cirF9"};